import { AppState, Auth0Provider } from '@auth0/auth0-react';

import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';

import { getConfig } from '../utils/getConfig.ts';

export const Auth0ProviderWithHistory = ({
  children,
}: PropsWithChildren<any>): JSX.Element | null => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState: AppState | undefined) => {
    const pathname = appState?.returnTo || window.location.pathname;
    const search = appState?.search ?? '';
    navigate(pathname + search);
  };

  return (
    <Auth0Provider
      domain={getConfig('AUTH0_DOMAIN')}
      clientId={getConfig('AUTH0_CLIENT_ID')}
      cacheLocation={import.meta.env.DEV ? 'localstorage' : 'memory'}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: getConfig('AUTH0_AUDIENCE'),
        scope: 'openid profile email',
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
